var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isBech32 ? _c('router-link', {
    staticClass: "addr monospace",
    attrs: {
      "to": _vm.internalURL
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.abbrev32[0]))]), _c('span', [_vm._v(_vm._s(_vm.abbrev32[1]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.abbrev32[2]))]), _c('span', [_vm._v(_vm._s(_vm.abbrev32[3]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.abbrev32[4]))])]) : _c('a', {
    staticClass: "addr monospace",
    attrs: {
      "href": "".concat(_vm.externalURL)
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.abbrevHex[0]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.abbrevHex[1]))]), _c('span', [_vm._v(_vm._s(_vm.abbrevHex[2]))]), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.abbrevHex[3]))])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }